import {
  Activity,
  BarChart,
  BarChart2,
  BookOpen,
  Brain,
  Briefcase,
  Building,
  Coins,
  Database,
  FileText,
  Globe,
  Landmark,
  LineChart,
  MessageCircle,
  MessageSquare,
  Newspaper,
  type LucideIcon,
  Percent,
  PieChart,
  Radio,
  Repeat,
  Rocket,
  Send,
  Server,
  Sprout,
  Target,
  TrendingUp,
  Vote,
  SquarePlay,
  Wallet,
} from 'lucide-react';

/** Icon for a platform in the catalog (`PlatformDef.icon`). */
export const PLATFORM_ICONS: Record<string, LucideIcon> = {
  // lucide-react 1 ships no brand marks (as `twitter` → Globe): a play tile stands for YouTube.
  youtube: SquarePlay,
  twitter: Globe,
  'message-circle': MessageCircle,
  'line-chart': LineChart,
  send: Send,
  'message-square': MessageSquare,
  wallet: Wallet,
  brain: Brain,
  building: Building,
  landmark: Landmark,
  percent: Percent,
  repeat: Repeat,
  'trending-up': TrendingUp,
  'bar-chart-2': BarChart2,
  sprout: Sprout,
  vote: Vote,
  'bar-chart': BarChart,
  briefcase: Briefcase,
  activity: Activity,
  rocket: Rocket,
  'file-text': FileText,
  'pie-chart': PieChart,
  database: Database,
  server: Server,
  target: Target,
  newspaper: Newspaper,
};

/** Icon for a source category group. */
export const CATEGORY_ICONS: Record<string, LucideIcon> = {
  social: Globe,
  on_chain: Wallet,
  defi: Coins,
  institutional: Building,
  research: BookOpen,
  market_infra: Radio,
};
